import styled from 'styled-components';
import landing from 'Assets/landing.svg';
import ending from 'Assets/ending.svg';
import spacer1 from 'Assets/spacer1.svg';
import spacer2 from 'Assets/spacer2.svg';

const page = `
    height:100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const spacer = `
    aspect-ratio: 1080/100;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;
const shadow = `
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04),
                    0px 0px 2px rgba(0, 0, 0, 0.02);

    `;
// SPACERS

export const SpacerOne = styled.div `
    ${spacer}
    background-image: url(${spacer1});
`;

export const SpacerTwo = styled.div `
${spacer}
background-image: url(${spacer2});
`;
//

// PAGES

export const LandingPage = styled.div`
    background-image: url(${landing});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;

    div:first-child {
    display: flex;
    justify-content: center;
    }
    ${page}
`;

export const EventPage = styled.div`
    ${page}
    height: fit-content;
    background-color: #f4940c;
    display: flex;
    flex-direction: column;
    padding: 0 15%;

    @media screen and (max-width: 1100px) {
        gap: 3rem;
        padding: 2rem 15%;
    }
`;

export const EndingPage = styled.div`
    background-image: url(${ending});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    ${page}
`;
//

export const Img = styled.img`
    width: 90%;
    max-width: 900px;
    margin-bottom: 1rem;
`;
export const Button = styled.button`
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.color || '#fff'};
    border-radius: 0.7rem;
    height: 30px;
    width: 120px;
    ${shadow}
    :hover{
        transform: scale(1.05);
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2),
                    0px 0px 2px rgba(0, 0, 0, 0.02);
                    cursor: pointer;
    }
    transition-duration: 0.5s;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
`;

export const scrollAnim = styled.div`
    margin-top: 3rem;
    width: 30px;
	height: 30px;
	border: 2px solid #0073b8;
	border-radius: 50%;
	position: relative;
	animation: down 3s infinite;
	-webkit-animation: down 3s infinite;
	&::before {
		content: '';
		position: absolute;
		top: 7px;
		left: 9px;
		width: 9px;
		height: 9px;
		border-left: 2px solid #0073b8;
  	border-bottom: 2px solid #0073b8;
		transform: rotate(-45deg);
	}
    @keyframes down {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translateY(15px);
        }
        40% {
            transform: translate(0);
        }
    }

    @-webkit-keyframes down {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translateY(15px);
        }
        40% {
            transform: translate(0);
        }
    }
`;

export const EventCard = styled.div `
    text-align: center;
    padding: 0.5rem 1rem;
    width: 300px;
    flex-shrink: 0;
    height: 440px;
    border-radius: 2rem;
    background-color: white;
    ${shadow}
    transform: rotateZ(${(props) => props.rotate || '0deg'});
    align-self: ${(props) => props.left ?  'flex-end': 'flex-start'};
    img{
        width: 100%;
        border-radius: 2rem;
    }
    p{
        font-weight: 500;
        margin-top: 1rem;
        margin-bottom: 0;
    }

    @media screen and (max-width: 1100px) {
        transform: rotateZ(0);
    }
`;

export const EventRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5rem;

    .react-reveal{
        display: flex;
        justify-content: center;
    }
    @media screen and (max-width: 1100px) {
        flex-direction: column;
        gap: 2rem;
    }
`;
export const RowTitle = styled.span`
    font-size: 50px;
    color:  white;
    font-family: 'Gloria Hallelujah', cursive;

    align-self: center;
    @media screen and (max-width: 800px) {
        font-size: 30px;
    }
`;

export const Title = styled.span`
    color: black;
    font-size: 50px;
    font-family: 'Gloria Hallelujah', cursive;
    @media screen and (max-width: 800px) {
        font-size: 25px;
    }
`;
export const Subtitle = styled.span`
    color: black;
    font-size: 30px;
    font-family: 'Gloria Hallelujah', cursive;

    margin-bottom: 1rem;

    @media screen and (max-width: 800px) {
        font-size: 20px;
    }
`;

export const Solution = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 500px;

    gap: 0.5rem;
    @media screen and (max-width: 800px) {
        width: 350px;
    }
    p{
        font-size: 20px;
        margin-bottom: 0;

        @media screen and (max-width: 800px) {
        font-size: 14px;
    }
    }
    a{
        font-weight: bold;
    }
    img{
        border: 1px solid;
        border-radius: 20px;
        height: 3rem;

        @media screen and (max-width: 800px) {
            height: 2rem;
    }
    }
`;

export const Spacer = styled.div`
    margin: 1rem;
`;